import { render, staticRenderFns } from "./ChangeEmailPage.vue?vue&type=template&id=1ed0cff2&scoped=true"
import script from "./ChangeEmailPage.vue?vue&type=script&lang=ts"
export * from "./ChangeEmailPage.vue?vue&type=script&lang=ts"
import style0 from "./ChangeEmailPage.vue?vue&type=style&index=0&id=1ed0cff2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed0cff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed0cff2')) {
      api.createRecord('1ed0cff2', component.options)
    } else {
      api.reload('1ed0cff2', component.options)
    }
    module.hot.accept("./ChangeEmailPage.vue?vue&type=template&id=1ed0cff2&scoped=true", function () {
      api.rerender('1ed0cff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ChangeEmailPage.vue"
export default component.exports